export enum BorderTypeEnum {
    SQUARE = 'square',
    CIRCLE = 'circle',
    OVAL = 'oval',
}

export enum LayoutType {
    WITH_BANNER = 1,
    WITHOUT_BANNER = 2,
}
